<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-if="id > 0 && load == 2"
  />
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-else-if="id == 0 && load == 1"
  /> 
  <Form 
    :d_form='c_form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_tujuan='lkp_tujuan'
    v-else-if="id == 0 && load == 2"
  /> 
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'perubahan.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Permohonan Pengurusan Perubahan', route: '/perubahan/permohonan/0' },
      ],
      title : 'Butiran Dan Rekod Perkembangan Bulanan Ternakan',
      tabs: [
           { title: 'PERMOHONAN', content: '' },
            { title: 'TERNAKAN', content: ''},
            { title: 'MUAT NAIK DOKUMEN', content: ''},
          ],
      form : {
        id : 0,
        premis_id : '',
        lkp_negeri_id : '',
        lkp_status_id : '',
        lkp_ternakan_id : '',
        kode : '',
        p : 0,
        nama: '',
        no_tel: '',
        alamat: '',
        ternakan_list : [],
        lkp_berahi_id: '',
         jenis_semen:'',
      },
      c_form:{
         id : 0,
         premis_id : '',
         lkp_negeri_id : '',
         lkp_status_id : '',
         lkp_ternakan_id : '',
         kode : '',
         p : 0,
         ternakan_list : [],
         lkp_berahi_id: '',
         juruteknik_id: '',
         jenis_semen:'',
         nama: '',
          emel: '',
          alamat: '',
      },
      premis_id : [],
      ternakan_list:[],
      premis : [],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      status_singkir : [],
      load : 0
      
      
      
    }
  },
  methods: {
    
getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'baka/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }
      
    },
    getSalin(id){
      var now = new Date();
        this.$zcomm.get(this.api_service + 'baka/show/'+id, {}).then(res => {
          this.form = res;
          this.c_form.id = 0;
          this.c_form.premis_id = res.premis_id;
          this.c_form.lkp_ternakan_id = res.lkp_ternakan_id;
          this.c_form.lkp_negeri_id = res.lkp_negeri_id;
          this.c_form.lkp_ternakan_id = res.lkp_ternakan_id;
          this.c_form.lkp_negeri = res.lkp_negeri;
          this.load = this.load + 1
        })

       
      },

    getNegeri(){
         this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.lkp_negeri = res
            this.load = this.load + 1
         })
    },

    onPremisSelected(value) {
    const selected = this.premis.find(p => p.value === value)
    if (selected) {
      this.d_form.nama = selected.nama_premis || ''
      this.d_form.emel = selected.emel || ''
      this.d_form.alamat = selected.alamat || ''
    } else {
      this.d_form.nama = ''
      this.d_form.emel = ''
      this.d_form.alamat = ''
    }
  },

   

  
  },

  watch: {

  },
  mounted() {
    this.getData()
    this.getNegeri()
    // this.getTujuanPd()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.salin && this.params.salin > 0){
      
      this.getSalin(this.params.salin)
    }
    
  }
    
}
</script>
